export default "__VITE_ASSET__BhsCClxJ__"